module.exports = __webpack_public_path__ + "img/background-footer.763c5942.jpg";